const webData = [
    {
      id: 7,
      name: "Tweet Archiver",
      date: "June 2020",
      description: "I use Twitter a lot to record my thoughts so I made a webtool to grab my data and organize them with tags. It's purely meant for personal scrapbooking purposes.",
      built: "Gatsby, React, Redux, Bootstrap, GraphQL",
      imageURL: 'https://imgur.com/a5vu79E.png',
      altText: "Archiver Screenshot",
      links: {"Github": "https://github.com/tpeng3/penguinhut"},
      tag: ["web", "programming"]
    },
    {
      id: 1,
      name: "this website!",
      date: "Summer 2019",
      description: "I used to host my portfolio on Weebly, but I decided to rebuild all the components with React as a learning project.",
      built: "Gatsby, React, Bootstrap",
      imageURL: 'https://imgur.com/SHPaSDi.png',
      altText: "Website Screenshot",
      links: {"Weebly Site": "https://shuttlefrog.weebly.com"},
      tag: ["web", "programming"]
    },
    {
        id: 2,
        name: "Savor Saber",
        date: "Fall 2018 - Present​",
        description: 'Art Director, Producer, and Pixel Artist/Animator for a slash and skewer adventure game about a robot feeding food to Eldritch Gods. I also designed and coded the public website!',
        addText: "Won both the Visual Arts and Worldbuilding Award at the 2019 UCSC Showcase.",
        imageURL: "https://imgur.com/iXvlb6J.png",
        altText: "Savor Saber Screenshot",
        built: "HTML5, Bootstrap",
        links: {"Website": "https://savorsaber.com/",
                "Game Page": "https://shuttlefrog.itch.io/savor-saber",
                "Twitter": "https://twitter.com/SAVORSABER"},
        tag: ["art", "game", "web", "programming", "featured"]
    },
    {
      id: 3,
      name: 'Okinawa Memory Initiative',
      date: "Fall 2018​",
      description: "Front-end Lead Programmer for a website hosting documents and articles related to Okinawan history during American military occupation. This is side website to the Gail Project.",
      built: "React, Bootstrap, Django, SQLite",
      imageURL: 'https://shuttlefrog.weebly.com/uploads/2/8/6/2/28624773/fdfdg_3.png',
      altText: 'OMI Screenshot',
      links: {"Github": "https://github.com/tpeng3/Okinawa-Initiative",
              "Gail Project Site": "https://gailproject.ucsc.edu/"},
      tag: ["web", "programming"]
    },
    {
      id: 4,
      name: "Null Metal Detective: Tactical Schedule Management",
      date: "Spring 2018​",
      description: "Artist, Programmer and Writer for a time management visual novel about an incompetent detective. It also doubles as a bullet hell game.",
      addText: "Featured in the 2018 Sammy Showcase.",
      built: "Phaser, Javascript",
      imageURL: 'https://shuttlefrog.weebly.com/uploads/2/8/6/2/28624773/nmd-screencap_orig.png',
      altText: 'Typocrypha Screenshot',
      links: {"Game Page": "https://hanmori.itch.io/harold",
              "Github": "https://github.com/tpeng3/Endless-Runner",
              "Dev Video": "Available upon request."},
      tag: ["programming", "art", "game"]
    },
    {
      id: 5,
      name: "Harold, they're Lesbians",
      date: "Spring 2018​",
      description: "Solo project. Programmer and Artist for a short endless runner about a phantom thief and police detective.",
      addText: "Nominated for Sonic '06 Best Runner 2018 (in-class joke award)",
      imageURL: "https://shuttlefrog.weebly.com/uploads/2/8/6/2/28624773/screenshot1_orig.png",
      altText: 'Harold Screenshot',
      built: "Phaser, Javascript",
      links: {"Game Page": "https://hanmori.itch.io/harold",
              "Github": "https://github.com/tpeng3/Endless-Runner",
              "Dev Video": "https://youtu.be/JAerYD-Mx7Y"},
      tag: ["art", "game"]
    },
    {
      id: 6,
      name: "Rubik's Cube Teacher as AI",
      date: "Fall 2017",
      description: "Lead Programmer for an AI program that gives the players tips on how to solve a Rubik's cube, using behavior trees.",
      built: "HTML5, Javascript",
      imageURL: 'https://shuttlefrog.weebly.com/uploads/2/8/6/2/28624773/294260296_1_orig.jpg',
      altText: 'Rubiks Screenshot',
      links: {"Demo Video": "https://www.youtube.com/watch?v=n9YwXZanT5o",
              "Github": "https://github.com/mmmayr/cube-destroyers"},
      tag: ["programming"]
    }
];

export default webData;